import { Container } from '@/components';

const ProductVideo: React.FC<{ videoIframe: string }> = ({ videoIframe }) => {
  return (
    <Container dangerouslySetInnerHTML={{ __html: videoIframe }}></Container>
  );
};

export default ProductVideo;
